// extracted by mini-css-extract-plugin
export default {"root":"IconTrash_root__3qn0g"};